import { ReviewReason } from '@lio/rule-engine';
import { Item } from '@components/select/Select';

export const REVIEW_REASON_LABELS: Record<ReviewReason, string> = {
  [ReviewReason.AdverseRiskNotice]: 'Adverse Risk Notice',
  [ReviewReason.GenericOffer]: 'Generic Offer',
  [ReviewReason.LossException]: 'Loss Exception',
  [ReviewReason.NoticeOfConditionalRenewal]: 'Notice Of Conditional Renewal',
  [ReviewReason.ReinsuranceOnPolicy]: 'Reinsurance On Policy',
  [ReviewReason.RateChange]: 'Rate Change',
};

export const REVIEW_REASON_OPTIONS: Item[] = Object.entries(REVIEW_REASON_LABELS).map(([value, label]) => ({
  value,
  label,
}));
